import type { z } from 'zod';
import {
  checkDomainFormat,
  checkNewDomain,
  domainFieldsSchema,
  INVALID_DOMAIN_NAME_ERR,
  NEW_DOMAIN_NAME_ERR,
} from '../domainFields.schema.ts';
import {
  addIdentityProviderBaseFormSchema,
  editIdentityProviderBaseFormSchema,
} from '../IdentityProviderBaseForm.schema.ts';

// Edit
export const editAdminIdentityProviderFormSchema = editIdentityProviderBaseFormSchema
  .extend(domainFieldsSchema)
  .refine(checkNewDomain, NEW_DOMAIN_NAME_ERR)
  .refine(checkDomainFormat, INVALID_DOMAIN_NAME_ERR);
export type EditAdminIdentityProviderFormData = z.input<typeof editAdminIdentityProviderFormSchema>;
export type EditAdminIdentityProviderTransformedData = z.infer<typeof editAdminIdentityProviderFormSchema>;

// Add
export const addAdminIdentityProviderFormSchema = addIdentityProviderBaseFormSchema
  .extend(domainFieldsSchema)
  .refine(checkNewDomain, NEW_DOMAIN_NAME_ERR)
  .refine(checkDomainFormat, INVALID_DOMAIN_NAME_ERR);
export type AddAdminIdentityProviderFormData = z.input<typeof addAdminIdentityProviderFormSchema>;
export type AddAdminIdentityProviderTransformedData = z.infer<typeof addAdminIdentityProviderFormSchema>;
